import type { Variants } from 'framer-motion';

export const variantsFadeInUp: Variants = {
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.3,
            staggerChildren: 0.1,
        },
    },
    hidden: {
        opacity: 0,
        y: 7,
        transition: {
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.3,
            staggerChildren: 0.1,
        },
    },
};

export const variantsChildren: Variants = {
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            ease: 'easeInOut',
        },
    },
    hidden: {
        opacity: 0,
        y: 10,
    },
};

export const variantsFadeInLeft: Variants = {
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.2,
            staggerChildren: 0.1,
        },
    },
    hidden: {
        opacity: 0,
        x: 7,
    },
};
